import React, { useState, useEffect } from "react";
import { Button, Grid as Grid2, Box } from "@mui/material";
import Typography from "@mui/material/Typography";

const SingleImageUpload = ({ onImageChange, value }) => {
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const module = "SingleImageUpload";

  useEffect(() => {
    console.debug(`[${module}] useEffect triggered with value:`, value);
    if (value) {
      if (typeof value === "string") {
        console.debug(`[${module}] useEffect: Value is a string (URL):`, value);
        setImagePreview(value);
      } else if (value && value.file) {
        console.debug(`[${module}] useEffect: Value has a file object:`, value);
        setImage(value.file);
        const reader = new FileReader();
        reader.onloadstart = () => {
          console.debug(
            `[${module}] useEffect: reader.onloadstart: Reading file:`,
            value.file.name
          );
        };
        reader.onprogress = (event) => {
          if (event.lengthComputable) {
            const percentLoaded = Math.round(
              (event.loaded / event.total) * 100
            );
            console.debug(
              `[${module}] useEffect: reader.onprogress: Loading ${value.file.name}: ${percentLoaded}%`
            );
          }
        };
        reader.onloadend = () => {
          setImagePreview(reader.result);
          console.debug(
            `[${module}] useEffect: reader.onloadend: Image preview loaded for`,
            value.file.name
          );
        };
        reader.onerror = (error) => {
          console.error(
            `[${module}] useEffect: reader.onerror: Error loading image preview:`,
            error
          );
        };
        reader.readAsDataURL(value.file);
      } else {
        console.debug(
          `[${module}] useEffect: Value is null or invalid, clearing image`
        );
        setImage(null);
        setImagePreview(null);
      }
    } else {
      console.debug(`[${module}] useEffect: Value is null, clearing image`);
      setImage(null);
      setImagePreview(null);
    }
  }, [value]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.warn(`[${module}] handleImageChange: No file selected.`);
      return;
    }
    console.debug(`[${module}] handleImageChange: Image selected:`, file.name);
    setImage(file);
    const reader = new FileReader();
    reader.onloadstart = () => {
      console.debug(
        `[${module}] handleImageChange: reader.onloadstart: Reading file:`,
        file.name
      );
    };
    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentLoaded = Math.round((event.loaded / event.total) * 100);
        console.debug(
          `[${module}] handleImageChange: reader.onprogress: Loading ${file.name}: ${percentLoaded}%`
        );
      }
    };
    reader.onloadend = () => {
      setImagePreview(reader.result);
      console.debug(
        `[${module}] handleImageChange: reader.onloadend: Image preview loaded for`,
        file.name
      );
    };
    reader.onerror = (error) => {
      console.error(
        `[${module}] handleImageChange: reader.onerror: Error loading image preview:`,
        error
      );
    };
    reader.readAsDataURL(file);
    onImageChange({ file: file, description: "" }); // Send empty description
  };

  const handleRemoveImage = () => {
    console.debug(`[${module}] handleRemoveImage: Image removed`);
    setImage(null);
    setImagePreview(null);
    onImageChange({ file: null, description: "" }); // Send empty description
  };

  const removeButtonStyle = {
    position: "absolute",
    top: "0px",
    right: "0px",
    minWidth: "auto",
    padding: "4px",
    fontSize: "0.7rem",
  };

  const imageContainerStyle = {
    position: "relative",
    display: "inline-block",
    width: "100%",
    maxWidth: "150px",
    height: "auto",
  };

  return (
    <Grid2 container spacing={2} alignItems="center">
      <Grid2 item xs={12}>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: "block" }}
          id="single-image-upload"
        />
      </Grid2>
      {imagePreview && (
        <Grid2 item xs={12} sm={6} md={4} lg={3}>
          <Box sx={imageContainerStyle}>
            <Button
              variant="outlined"
              color="error"
              onClick={handleRemoveImage}
              size="small"
              sx={removeButtonStyle}
            >
              X
            </Button>
            <img
              src={imagePreview}
              alt="Uploaded image"
              width="100%"
              style={{ display: "block" }}
            />
          </Box>
        </Grid2>
      )}
      {value && typeof value === "string" && (
        <Grid2 item xs={12}>
          <Typography color="success">Image uploaded!</Typography>
        </Grid2>
      )}
    </Grid2>
  );
};

export default SingleImageUpload;
